import React from "react"
import PropTypes from "prop-types"
import {Link, withRouter} from 'react-router-dom';
import {Col, FormControl, FormGroup, Row} from "react-bootstrap"
import {TableHeaderColumn} from "react-bootstrap-table"
import BaseGrid from "../BaseGrid"
import FormButtons from "../form/FormButtons"
import {Acl, Grid, Party, qs} from "../../utils"

const partyTypeOptions = [
	{value: 'PERSON', label: 'FO'},
	{value: 'COMPANY', label: 'PO'},
];

const isVatOptions = [
	{value: true, label: 'DPH'},
	{value: false, label: 'ne'}
];

const isMailInvoiceOptions = [
	{value: true, label: <i className={'fa fa-file'}/>, title: 'Stahování faktur z emailů'},
	{value: false, label: 'ne'}
];

class Parties extends BaseGrid {

	constructor(props) {
		super(props);

		this.state = {
			...this.state,
			action: null,
			actionModalOpen: null,
			actionItems: []
		};

		this.handleActionSelect = this.handleActionSelect.bind(this);
		this.handleActionSubmit = this.handleActionSubmit.bind(this);
		this.handleRowSelect = this.handleRowSelect.bind(this);
		this.handleRowSelectAll = this.handleRowSelectAll.bind(this);

		this.handleActionModalDismiss = this.handleActionModalDismiss.bind(this)
	}

	getDefaultFilter() {
		return {
			"statuses": ["NEW", "ACTIVE"],
			"isTracked": null,
			"isMailInvoice": null,
			"isVat": null,
			"isExtra": null,
			"partyType": null,
			"search": "",
			"orderCol": "title",
			"orderDir": "a",
			"start": 0,
			"rows": this.getDefaultPageRows()
		}
	}

	handleRowSelect({partyId}, isSelected) {
		const {actionItems} = this.state;
		if (isSelected) {
			this.setState({
				actionItems: [...actionItems, partyId].sort()
			});
		} else {
			this.setState({actionItems: actionItems.filter(it => it !== partyId)});
		}
		return false;
	}

	handleRowSelectAll(isSelected) {
		const {items, session} = this.props;
		if (!isSelected) {
			this.setState({actionItems: []})
		} else {
			const actionItems = [];
			for (let i = 0; i < items.length; i++) {
				if (!Acl.isAllowed(session, Acl.right.PARTY_NEW_GLOBAL) && items[i].partyId) {
					continue
				}
				actionItems.push(items[i].partyId)
			}
			this.setState({actionItems: actionItems})
		}
	}

	handleActionSelect(action) {
		this.setState({action: action})
	}

	handleActionSubmit() {
		const {actionItems, action} = this.state;
		if (!actionItems || !actionItems.length || !action || !action.value) {
			return
		}

		if ("archive" === action.value) {
			// this.props.onShowModal(
			// 	'Hromadné ukončení činnosti',
			// 	'Skutečně hromadně ukončit činnost vybraných členů (' + actionItems.length + ')?',
			// 	{style: 'danger', label: 'Hromadně ukončit činnost', icon: 'trash'},
			// 	() => this.props.onUpdatePartiestatus("deleted", actionItems).then((json) => {
			// 		if (json && json.response && json.response.result === 'OK') {
			// 			this.onFilterChange()
			// 		} else {
			// 			return new Promise((resolve, reject) => reject())
			// 		}
			// 	})
			// )

		} else {
			this.setState({actionModalOpen: true})
		}
	}

	handleActionModalDismiss() {
		this.setState({actionModalOpen: false})
	}

	renderActionModal() {
		// const {session} = this.props;
		const {actionModalOpen, actionItems} = this.state;
		if (!actionModalOpen) {
			return null
		}
		const {items} = this.props;
		const selected = [];
		if (items && items.length) {
			for (let i = 0; i < items.length; i++) {
				if (actionItems.indexOf(items[i].partyId) >= 0) {
					selected.push(items[i])
				}
			}
		}
	}

	handleSelectChange(name, value, submit = false) {
		const {filter} = this.state;
		// if (name === "eventId") {
		// 	if (filter.eventId && filter.eventId === value) {
		// 		return
		// 	}
		// 	const key = Enums.getKey("races", filter);
		// 	if (this.props.enums[key] && this.props.enums[key]["items"] && this.props.enums[key]["items"].length > 0) {
		// 		// auto-select 1st option
		// 		filter.raceId = this.props.enums[key]["items"][0]['id']
		// 	} else {
		// 		filter.raceId = ""
		// 	}
		// 	filter.compGroupIds = []
		// }
		// if (name === "raceId") {
		// 	if (filter.raceId && filter.raceId === value) {
		// 		return
		// 	}
		// 	filter.compGroupIds = []
		// }

		filter[name] = value;
		this.setState({filter: filter}, () => {
			// if (name === "xxx") {
			// this.props.onFetchEnums(["xx", "xx"], value, null, filter)
			// }
			this.onFilterChange()
		})
	}

	formatLink(cell, row) {
		return <Link to={{pathname: "/parties/" + cell}}>{cell}</Link>
	}

	formatPartyType(cell, row) {
		switch (cell) {
			case "PERSON":
				return <i className={"fa fa-user"}/>;
			case "COMPANY":
				return <i className={"fa fa-industry"}/>;
			default:
				return cell
		}
	}

	formatAbbr(cell, row) {
		return <span title={cell}>{cell}</span>;
	}

	formatEmail(cell, row) {
		return <span>{row.isMailInvoice ? <i title={'Stahování faktur'} className={'fa fa-file'}/> : null} {cell}</span>
	}

	formatIsVat(cell, row) {
		return cell ? <i className={'fa fa-check'}/> : null
	}

	formatAccounts(cell, row) {
		if (!cell || !cell.length) {
			return null
		}
		const items = [];
		for (let i = 0; i < cell.length; i++) {
			const a = cell[i];
			items.push(<div key={i} title={a.accountId}>{a.accountNo} {a.type ? <small>{Party.formatAccountType(a.type)}</small> : null}</div>)
		}

		return <div>{items}</div>;
	}

	formatExtra(cell, row) {
		if (!cell) {
			return null
		}
		const items = [];
		if (cell.vatPeriod) {
			items.push(<div key={'period'}>DPH: {Party.formatVatPeriod(cell.vatPeriod)}</div>)
		}
		if (cell.defaultPartAbbr) {
			items.push(<div key={'default'}>Partner: {cell.defaultPartAbbr}</div>)
		}
		if (cell.partners && cell.partners.length) {
			const partners = [];
			for (let i = 0; i < cell.partners.length; i++) {
				const p = cell.partners[i];
				partners.push(<span key={i}>{i > 0 ? ', ' : ''}<span className={p.isPrimary ? "text-success" : ""}>{p.partyAbbr}</span></span>)
			}
			items.push(<div key={'partners'}>{partners}</div>)
		}
		return <div>{items}</div>;
	}

	formatTrnCount(cell, row, dir) {
		return <Link to={{pathname: 'transactions', search: 'partyIds[]=' + row.partyId + '&trnDir=' + dir}}>{cell}</Link>
	}

	formatInvCount(cell, row, dir) {
		return <Link to={{pathname: 'invoices', search: 'partyIds[]=' + row.partyId}}>{cell}</Link>
	}

	formatRow(row, index) {
		if (row.isTracked) {
			return "text-info"
		}
		return (row && row.status === 'DELETED' ? "alert-muted" : null)
	}

	getFilter() {
		const {filter} = this.state;
		// const {enums} = this.props;

		return [
			<Row key="1">
				<Col xs={4}>
					<FormGroup>
						<FormControl type="text" value={filter.search} name="search" placeholder="Název, IČ, ..." onChange={this.handleInputChange}/>
					</FormGroup>
				</Col>
				<Col xs={2}>
					<FormButtons currentValue={filter.partyType} options={partyTypeOptions} name="partyType" onInputChange={this.handleInputChange}/>
				</Col>
				<Col xs={2}>
					<FormButtons currentValue={filter.isVat} options={isVatOptions} name="isVat" onInputChange={this.handleInputChange}/>
				</Col>
				<Col xs={2}>
					<FormButtons currentValue={filter.isMailInvoice} options={isMailInvoiceOptions} name="isMailInvoice" onInputChange={this.handleInputChange}/>
				</Col>
				{Grid.renderFilterButtons(this.onFilterReset, 2, () => {
					return '/rest/party/export/?' + qs.stringify(filter)
				})}
			</Row>];
	}

	getCols() {
		return [
			<TableHeaderColumn key="partyId" dataField="partyId" width='3%' dataAlign="center" dataSort={true} dataFormat={this.formatLink}>#</TableHeaderColumn>,
			<TableHeaderColumn key="partyType" dataField="partyType" width='3%' dataAlign="center" dataSort={true} dataFormat={this.formatPartyType}>Typ</TableHeaderColumn>,
			<TableHeaderColumn key="abbr" dataField="abbr" width='7%' dataAlign="center" dataSort={true} dataFormat={this.formatAbbr}>Zkr.</TableHeaderColumn>,
			<TableHeaderColumn key="title" dataField="title" width='14%' dataSort={true} dataFormat={this.formatAbbr}>Název</TableHeaderColumn>,
			<TableHeaderColumn key="companyNumber" dataField="companyNumber" width='7%' dataSort={true}>IČ</TableHeaderColumn>,
			<TableHeaderColumn key="taxNumber" dataField="taxNumber" width='9%' dataSort={true}>DIČ</TableHeaderColumn>,
			<TableHeaderColumn key="email" dataField="email" width='13%' dataSort={true} dataFormat={this.formatEmail}>E-mail</TableHeaderColumn>,
			<TableHeaderColumn key="isVat" dataField="isVat" width='4%' dataAlign="center" dataSort={true} dataFormat={this.formatIsVat}>DPH</TableHeaderColumn>,
			<TableHeaderColumn key="accounts" dataField="accounts" width='15%' dataFormat={this.formatAccounts}>Účet</TableHeaderColumn>,
			<TableHeaderColumn key="extra" dataField="extra" width='10%' dataFormat={this.formatExtra}>Extra</TableHeaderColumn>,
			<TableHeaderColumn key="trnFromCount" dataField="trnFromCount" width='3%' dataAlign="center" dataSort={true} dataFormat={(c, r) => this.formatTrnCount(c, r, 'IN')}>TP</TableHeaderColumn>,
			<TableHeaderColumn key="trnToCount" dataField="trnToCount" width='3%' dataAlign="center" dataSort={true} dataFormat={(c, r) => this.formatTrnCount(c, r, 'OUT')}>TO</TableHeaderColumn>,
			<TableHeaderColumn key="invToCount" dataField="invToCount" width='3%' dataAlign="center" dataSort={true} dataFormat={(c, r) => this.formatInvCount(c, r)}>FV</TableHeaderColumn>,
			<TableHeaderColumn key="invFromCount" dataField="invFromCount" width='3%' dataAlign="center" dataSort={true} dataFormat={(c, r) => this.formatInvCount(c, r)}>FP</TableHeaderColumn>,
		];
	}

	render() {
		const {isFetchingItems, items, count, filter, session} = this.props;

		const actions = [];
		if (Acl.isAllowed(session, Acl.party.CREATE)) {
			actions.push({
				value: "archive",
				label: 'Archivovat vše'
			})
		}

		const actionCtx = actions.length > 0 ? {
			onActionSelect: this.handleActionSelect,
			onActionSubmit: this.handleActionSubmit,
			value: this.state.action,
			key: 'partyId',
			selectRowProp: {
				mode: 'checkbox',
				clickToSelect: true,
				onSelect: this.handleRowSelect,
				onSelectAll: this.handleRowSelectAll,
				selected: this.state.actionItems,
				bgColor: function (row, isSelect) {
					if (isSelect) {
						return "#fcf8e3"
					}
					return null;
				},
				unselectable: []
			},
			actions: actions
		} : null;

		if (items && !Acl.isAllowed(session, Acl.right.PARTY_NEW_GLOBAL)) {
			for (let i = 0; i < items.length; i++) {
				if (items[i].partyId) {
					actionCtx.selectRowProp.unselectable.push(items[i].partyId)
				}
			}
		}

		return <div>{Grid.renderFull(isFetchingItems, items, count,
			Grid.getTableOptions(filter, this.onPageChange, this.onSortChange, this.onFilterChange, this.renderPaginationShowsTotal),
			this.getCols(),
			this.getFilter(),
			this.onFilterChange,
			actionCtx, this.formatRow)}
			{this.renderActionModal()}
		</div>
	}
}


Parties.propTypes = {
	onFetchEnums: PropTypes.func.isRequired,
	enums: PropTypes.object.isRequired,
	onShowModal: PropTypes.func.isRequired,
	onUpdatePartiestatus: PropTypes.func,
	onShowMessage: PropTypes.func.isRequired
};

export default withRouter(Parties)
